import React from 'react';

const CustomButton = ({ isCorrect, isSelected, submittedAnswer, text, isClosed, isThereCorrectAnswer, onClick }) => {
  /*
    On close state, if the correct answer is selected, show a check if not show a red x
    if not the correct answer highlight the correct green

  */

  // console.log(
  //   'XXXXXXXXX is there correct answer',
  //   isThereCorrectAnswer,
  //   'selected',
  //   isSelected,
  //   'correct',
  //   isCorrect,
  //   'text',
  //   text,
  //   'isClosed',
  //   isClosed
  // );
  const getClass = () => {
    // console.log(text,'iselected',isSelected,'is there correct answer',isThereCorrectAnswer)

    if (!isClosed && isSelected) {
      return 'selected';
    }

    if (isSelected && isThereCorrectAnswer) {
      // correct add the green check
      return isCorrect ? 'correct-button' : 'incorrect-button';
    } else if (isClosed && isCorrect) {
      // this means that the correct answer was not selected
      // show the green background
      return 'correct-answer';
    }

    return '';
  };

  return (
    <button
      type="submit"
      disabled={isClosed || submittedAnswer}
      className={`unbranded-button ${getClass()}`}
      onClick={onClick}
      dangerouslySetInnerHTML={{ __html: text }}
    ></button>
  );
};

export default CustomButton;
